<template>
  <div class="withdrawal-record" v-title data-title="提现记录">
    <!-- <header>
      <img src="../../assets/images/card-img/buy-card-img/icon-24-fanhui.png" alt="" @click="back"> 
      <p>
        提现记录
      </p>
    </header> -->
    <section>
      <div class="record-list" v-for="(item,index) in withdrawal_list" :key="index">
        <div class="left">
          <p>
            -{{item.money}}
          </p>
          <p v-if="item.status == 0">
            处理中
          </p>
          <p v-if="item.status == 1" style="color:red">
            已完成
          </p>
        </div>
        <div class="right">
          <p>
            {{item.create_time}}
          </p>
          <p>
            {{item.card_no}}    {{item.realname}}
          </p>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data(){
    return{
      withdrawal_list : [], // 列表
    }
  },
  created(){
    this.$axios.get('http://members.kfm666666.net/api/dcash/index/clist').then(res => {
      // console.log(res.data.data)
      this.withdrawal_list = res.data.data
    })
  },
  methods:{
    back(){
      this.$router.push({
        path: '/pay-record',
        query:{
          active : 2
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .withdrawal-record{
    width: 100%;
    // height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      border-bottom: .01rem #E4E4E4 solid;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
      }
    }
    section{
      width: 100%;
      flex: 1;
      overflow: scroll;
      // 提现列表
      .record-list{
        width: 100%;
        height: 1.4rem;
        border-bottom: .01rem #E5E5E5 solid;
        .left{
          float: left;
          margin-left: .3rem;
          p{
            &:first-child{
              width: 0.64rem;
              font-size: 0.32rem;
              line-height: .32rem;
              margin-top: .36rem;
              font-family: Source Han Sans CN Medium, Source Han Sans CN Medium-Medium;
              font-weight: 500;
              color: #50a70a;
            }
            &:last-child{
              font-size: 0.24rem;
              line-height: .24rem;
              margin-top: .28rem;
              font-family: Source Han Sans CN Normal, Source Han Sans CN Normal-Normal;
              font-weight: Normal;
              text-align: left;
              color: #666666;
            }
          }
        }
        .right{
          float: right;
          margin-right: .3rem;
          p{
            text-align: right;
            &:first-child{
              font-size: 0.2rem;
              line-height: 0.2rem;
              margin-top: .45rem;
              font-family: Source Han Sans CN Normal, Source Han Sans CN Normal-Normal;
              font-weight: Normal;
              color: #666666;
            }
            &:last-child{
              font-size: 0.24rem;
              line-height: 0.24rem;
              margin-top: .24rem;
              font-family: Source Han Sans CN Normal, Source Han Sans CN Normal-Normal;
              font-weight: Normal;
              color: #333333;
            }
          }
        }
      }
    }
  }
</style>